import React from 'react';
import { DialogTitle as MuiDialogTitle, DialogTitleProps as MuiDialogTitleProps } from '@mui/material';

type DialogTitleProps = MuiDialogTitleProps & {
  children?: any;
};

export const DialogTitle = ({ children = null, sx, ...rest }: DialogTitleProps) => {
  return (
    <MuiDialogTitle
      sx={{
        ...sx,
      }}
      {...rest}
    >
      {children}
    </MuiDialogTitle>
  );
};
